module.exports = __webpack_public_path__ + "img/green-small-grass-00.e7e84841.png";